//
//
//
//
//
//
//
//
//
//

import './reportContentActive.css'
import { documentContentStoreMixin } from './documentContentStoreMixin.js'

export default {
  name: 'ReportContentSection',
  mixins: [documentContentStoreMixin],
  inject: {
    injectedParentId: {
      from: 'parentContentSectionId', default: null
    },
    reportContentEnabled: {
      from: 'reportContentEnabled', default: true
    }
  },
  provide () {
    return { parentContentSectionId: this.contentSectionId }
  },

  props: {
    contentSectionId: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    weight: {
      type: Number,
      required: true
    },
    icon: {
      type: String,
      default: null
    },
    groupingOnly: {
      type: Boolean,
      default: false
    },
    manualParentId: {
      type: String,
      default: null
    },
    isOpen: {
      type: Boolean,
      default: undefined
    },
    register: {
      type: Boolean,
      default: true
    }
  },

  data () {
    return {
      isRegistered: false,
      registeredSectionId: null,
      registeredSignature: null
    }
  },

  computed: {
    activeSectionIdFromStore () {
      return this.contentGetter('getActiveSectionId')
    },
    checkActiveDescendant () {
      return this.contentGetter('hasActiveDescendant')
    },
    storeReady () {
      return this.reportContentEnabled !== false && !!(this.$store && this.$store.state[this.contentStoreModule])
    },
    activeSectionId () {
      return this.storeReady ? this.activeSectionIdFromStore : null
    },
    hasActiveDescendant () {
      if (!this.storeReady || typeof this.checkActiveDescendant !== 'function') {
        return false
      }
      return this.checkActiveDescendant(this.contentSectionId)
    },
    isActive () {
      return this.storeReady && this.activeSectionId === this.contentSectionId
    },
    wrapperClasses () {
      if (!this.storeReady) {
        return {}
      }
      const markAsActiveParent = !this.isActive && this.hasActiveDescendant && this.isOpen === false
      return {
        'report-content-section--active': this.isActive,
        'report-content-section--active-parent': markAsActiveParent
      }
    },
    hasExplicitManualParentId () {
      return Object.prototype.hasOwnProperty.call(this.$options.propsData || {}, 'manualParentId')
    },
    resolvedParentId () {
      if (this.hasExplicitManualParentId) {
        return this.manualParentId || null
      }
      return this.injectedParentId || null
    }
  },

  watch: {
    activeSectionId (newId) {
      if (!this.storeReady || this.isOpen === undefined) {
        return
      }

      if (newId === this.contentSectionId || this.hasActiveDescendant) {
        this.$emit('update:isOpen', true)
      }
    },
    contentSectionId: 'syncRegistration',
    title: 'syncRegistration',
    weight: 'syncRegistration',
    icon: 'syncRegistration',
    groupingOnly: 'syncRegistration',
    manualParentId: 'syncRegistration',
    register: 'syncRegistration',
    resolvedParentId: 'syncRegistration',
    storeReady: 'syncRegistration'
  },

  created: function () {
    this.syncRegistration()
  },

  mounted: function () {
    this.syncRegistration()
  },

  updated: function () {
    if (!this.storeReady) {
      return
    }
    const shouldRegister = this.register && (this.groupingOnly || this.hasDefaultContent())
    if (shouldRegister !== this.isRegistered) {
      this.syncRegistration()
    }
  },

  beforeDestroy: function () {
    this.maybeUnregister()
  },

  methods: {
    registerContentSection (payload) {
      return this.contentDispatch('registerContentSection', payload)
    },
    unregisterContentSection (id) {
      return this.contentDispatch('unregisterContentSection', id)
    },
    hasDefaultContent () {
      return !!(this.$slots.default && this.$slots.default.some(vnode => {
        return vnode && !vnode.isComment && (vnode.tag || vnode.text && vnode.text.trim())
      }))
    },
    getRegistrationPayload () {
      return {
        id: this.contentSectionId,
        parentId: this.resolvedParentId,
        weight: this.weight,
        title: this.title,
        icon: this.icon,
        groupingOnly: this.groupingOnly
      }
    },
    syncRegistration () {
      if (!this.storeReady) {
        this.maybeUnregister()
        return
      }

      const shouldRegister = this.register && (this.groupingOnly || this.hasDefaultContent())
      if (!shouldRegister) {
        this.maybeUnregister()
        return
      }

      const payload = this.getRegistrationPayload()
      const signature = JSON.stringify(payload)
      if (this.isRegistered && this.registeredSectionId !== this.contentSectionId) {
        this.maybeUnregister()
      }
      if (this.isRegistered && this.registeredSignature === signature) {
        return
      }

      this.isRegistered = true
      this.registeredSectionId = this.contentSectionId
      this.registeredSignature = signature
      this.registerContentSection(payload)
    },
    maybeUnregister () {
      if (!this.isRegistered) {
        return
      }
      const sectionId = this.registeredSectionId
      this.isRegistered = false
      this.registeredSectionId = null
      this.registeredSignature = null
      if (this.$store && this.$store.state[this.contentStoreModule]) {
        this.unregisterContentSection(sectionId)
      }
    }
  }
}
